var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-0.4 -1.493)"},[React.createElement("line",{"x2":"13.007","transform":"translate(0.93 11.22) rotate(-45)","fill":"none","stroke":"#fff","strokeWidth":"1.5","key":0}),React.createElement("line",{"x2":"13.007","transform":"translate(0.93 2.023) rotate(45)","fill":"none","stroke":"#fff","strokeWidth":"1.5","key":1})]));
}

IconClose.defaultProps = {"width":"10.258","height":"10.258","viewBox":"0 0 10.258 10.258"};

module.exports = IconClose;

IconClose.default = IconClose;
